var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-general-accounting-statement',{attrs:{"apiEndPoint":"/accounting/cashier-box/cashierBoxStatement/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }